import {isEmpty} from "@helpers/helpers";

const $densities = {
    'low': 'کم',
    'medium': 'متوسط',
    'high': 'زیاد',
};

export const DensityState = {
    show: false,
    options: [
        {label: 'کم', value: 'low', checked: false},
        {label: 'متوسط', value: 'medium', checked: false},
        {label: 'زیاد', value: 'high', checked: false},
    ],
    selected_items: [],
};

export const getDensities = (density = null) => {
    let densities = false;

    if (isEmpty(density)) {
        densities = $densities;
    } else if (typeof density === "string" && !isEmpty(density) && !isEmpty($densities[density])) {
        densities = $densities[density];
    } else if (typeof density === "object" && density.length) {
        densities = [];
        for (let item of density) {
            if (!isEmpty($densities[item])) {
                densities.push($densities[item])
            }
        }
    }

    return densities;
};